import { render } from "./SearchAIForm.vue?vue&type=template&id=4f6efd51&scoped=true"
import script from "./SearchAIForm.vue?vue&type=script&lang=js"
export * from "./SearchAIForm.vue?vue&type=script&lang=js"

import "./SearchAIForm.vue?vue&type=style&index=0&id=4f6efd51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6efd51"]])

export default __exports__